import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup, {RadioGroupProps} from '@material-ui/core/RadioGroup';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import * as React from 'react';
import {BILLING_PERIOD} from '../../MyAccount/AccountPage/PlanAndBilling/Consts';
import {useCallback} from 'react';
const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      justifyContent: 'center',
      marginTop: theme.spacing(1),
    },
    selectedLabel: {
      color: theme.palette.secondary.main,
    },
  })
);

export default function BillingPeriodSwitch({
  selectedBillingPeriod,
  onChange,
}: {
  selectedBillingPeriod: number;
  onChange: (value: number) => void;
}) {
  const {root, selectedLabel} = useStyles();
  const handleChange = useCallback<RadioGroupProps['onChange']>((event, value) => onChange(parseInt(value)), [
    onChange,
  ]);
  const value = String(selectedBillingPeriod);
  return (
    <RadioGroup row className={root} value={value} onChange={handleChange}>
      <FormControlLabel
        id="cla-radio-yearly"
        value={String(BILLING_PERIOD.YEAR)}
        classes={{label: value === String(BILLING_PERIOD.YEAR) ? selectedLabel : undefined}}
        control={<Radio color="secondary" />}
        label="Yearly SAVE 20%"
      />
      <FormControlLabel
        id="cla-radio-monthly"
        value={String(BILLING_PERIOD.MONTH)}
        classes={{label: value === String(BILLING_PERIOD.MONTH) ? selectedLabel : undefined}}
        control={<Radio />}
        label="Monthly"
      />
    </RadioGroup>
  );
}
